import { useParams, useNavigate, Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import EmployeeView from './EmployeeView';
import EmployeeDocument from './EmployeeDocument';
import { useAuth } from '../../../context/AuthContext';
import withPermission from '../../../utils/withPermission';
import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs";
import EmployeeModal from './EmployeeModal';
import EmployeeContract from './EmployeeContract';
import EmployeeProjects from './EmployeeProjects';

const EmployeeDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [EmployeeDetails, setEmployeeDetails] = useState(null);
    const [activeTab, setActiveTab] = useState('transactionList');
    const didFetchRef = useRef(false);
    const [Employees, setEmployee] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [industries, setIndustries] = useState([]);
    const WithContactPermission = withPermission(({ children }) => children, ['employeedoc-list']);
    const WithContractPermission = withPermission(({ children }) => children, ['employeecontract-list']);


    useEffect(() => {
        if (!didFetchRef.current) {
            fetchEmployeeDetails();
            didFetchRef.current = true;
        }
    }, [id]);

    const fetchEmployeeDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;
            const response = await axios.get(`${backendUrl}/api/employee/${id}`, {
                headers: { 'Authorization': `Bearer ${token}`,
                'Tenant-Origin': origin,
            },
            });
            setEmployeeDetails(response.data.data);
        } catch (error) {
            console.error('Error fetching Employee details:', error);
        }
    };
    const editEmployee = async (contactId, updatedData) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            const response = await axios.put(`${backendUrl}/api/employee/${contactId}`, updatedData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            const updatedEmployee = response.data.Data;

            if (updatedEmployee) {
                // ✅ Update Employee details state
                setEmployeeDetails(updatedEmployee);

                // ✅ Update the Employees list state if needed
                setEmployee((prevEmployees) =>
                    prevEmployees
                        ? prevEmployees.map((org) =>
                            org.id === updatedEmployee.id ? updatedEmployee : org
                        )
                        : [updatedEmployee] // If null, set it as an array
                );
            } else {
                console.error('Update failed, no data returned.');
            }
            setShowModal(false);
        } catch (error) {
            if (error.response?.data?.errors) {
                return error.response.data.errors; // Return validation errors
            } else {
                console.error(`Error updating`, error);
            }
        }
    };


    const fetchIndustries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let allIndustries = [];
            let currentPage = 1;
            let lastPage = 1;


            const response = await axios.get(`${backendUrl}/api/industries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,

            });

            allIndustries = [...allIndustries, ...response.data.industry]


            setIndustries(allIndustries);
        } catch (error) {
            console.error('Error fetching industries:', error);
        }
    };
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                {/* 🔹 Back Button & Title */}
                                <h4 className="mb-sm-0 d-flex align-items-center">
                                    <BsChevronLeft
                                       className='back-button1'
                                        onClick={() => navigate(-1)}
                                    />
                                    <span>Employee</span>
                                </h4>

                            </div>
                        </div>
                    </div>

                    <div className="p-6 max-w-7xl mx-auto">
                        {/* Employee Info Card */}
                        {/* {EmployeeDetails && ( */}
                        <>
                            {/* Internal Styles */}
                            

                            <Card className="mb-4 shadow-lg rounded-3 p-2 border-0 card-bg">
                                {/* Header Section with Name and Edit Icon */}
                                <div className="d-flex justify-content-between align-items-center">
                                    <Card.Title className="fw-bold font-size-14 text-primary">{EmployeeDetails?.first_name}</Card.Title>
                                    <BiPencil
                                        className="text-primary hover-effect2 edit-pencil"
                                        onClick={() => {
                                            setSelectedEmployee(EmployeeDetails); // Store Employee details
                                            setShowModal(true); // Open modal
                                        }} />
                                </div>
                                <Card.Body className="pt-3">
                                    <div className="row">
                                        {/* Left Section */}
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Type:</strong></span>
                                                <span className="text-muted card-value">{EmployeeDetails?.employee_category || '-'}</span>
                                            </div>
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Phone:</strong></span>
                                                <span className="text-muted card-value">{EmployeeDetails?.personal_mobile || '-'}</span>
                                            </div>
                                        </div>

                                        {/* Right Section */}
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Email:</strong></span>
                                                <span className="fw-semibold text-primary card-value">{EmployeeDetails?.personal_email || ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            {showModal && (
                                <EmployeeModal
                                    showModal={showModal}
                                    handleClose={() => setShowModal(false)}
                                    orgData={selectedEmployee} // Pass data here
                                    editOrg={editEmployee}
                                    fetchIndustries={fetchIndustries}
                                    orgId={id}
                                    industries={industries}
                                />
                            )}

                        </>


                        {/* )} */}
                        <div className="row">
                            <div className="col-xl-12 col-lg-8">
                                <div className="card">
                                    {/* Nav tabs */}
                                    <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
                                        <WithContactPermission>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'transactionList' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('transactionList')}
                                                role="tab"
                                            >
                                                Documents
                                            </a>
                                        </li>
                                        </WithContactPermission>
                                         <WithContractPermission>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'contractList' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('contractList')}
                                                role="tab"
                                            >
                                                Contracts
                                            </a>
                                        </li>
                                         <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'assignedProjects' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('assignedProjects')}
                                                role="tab"
                                            >
                                                Assigned Projects
                                            </a>
                                        </li>
                                        </WithContractPermission>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'EmployeeDetails' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('EmployeeDetails')}
                                                role="tab"
                                            >
                                                Employee Details
                                            </a>
                                        </li>
                                    </ul>


                                    {/* Tab panes */}
                                    <div className="tab-content p-4">
                                        {/* Contact List Tab */}
                                        {activeTab === "transactionList" && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">
                                                    <EmployeeDocument
                                                        EmployeeId={EmployeeDetails?.id}
                                                        entityType="org"
                                                        fetchEmployeeData={fetchEmployeeDetails}
                                                        EmployeeData={EmployeeDetails}
                                                        setEmployeeDetails={setEmployeeDetails}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === "contractList" && (
                                            <div className="tab-pane active" id="contract-list" role="tabpanel">
                                                <div className="p-3">
                                                    <EmployeeContract
                                                        EmployeeId={EmployeeDetails?.id}
                                                        entityType="org"
                                                        fetchEmployeeData={fetchEmployeeDetails}
                                                        EmployeeData={EmployeeDetails}
                                                        setEmployeeDetails={setEmployeeDetails}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === "assignedProjects" && (
                                            <div className="tab-pane active" id="assigned-projects" role="tabpanel">
                                                <div className="p-3">
                                                    <EmployeeProjects
                                                        EmployeeId={EmployeeDetails?.id}
                                                        entityType="org"
                                                        fetchEmployeeData={fetchEmployeeDetails}
                                                        EmployeeData={EmployeeDetails}
                                                        setEmployeeDetails={setEmployeeDetails}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        {/* Employee Details Tab */}
                                        {activeTab === "EmployeeDetails" && (
                                            <div className="tab-pane active" id="Employee-details" role="tabpanel">
                                                <div>
                                                    {EmployeeDetails ? (
                                                        <EmployeeView
                                                            data={EmployeeDetails}
                                                            type="org"
                                                            EmployeeId={id}
                                                            setEmployeeDetails={setEmployeeDetails}
                                                        />
                                                    ) : (
                                                        <p>Loading...</p>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>

                        </div>



                    </div>
                </div>
            </div>
        </div>
    );
};
export default EmployeeDetails;
